import { makeStyles } from '@mui/styles';

export default makeStyles({
  option: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'block',
  },
});
